import _pickBy from 'lodash/pickBy';

export const isCalcParticipatingAdjustmentType = (text) => {
  const OTHER_CONSIDERATION = 'other consideration';
  const OTHER_CONSIDERATIONS = 'other considerations';
  const textLowerCase = text.toLowerCase();

  const isOtherConsiderations =
    textLowerCase === OTHER_CONSIDERATION ||
    textLowerCase === OTHER_CONSIDERATIONS;

  return !isOtherConsiderations;
};

export const adjustmentTypesParticipatingInCalculations = (adjustmentTypes) => {
  const calcParticipants = _pickBy(adjustmentTypes, (_, key) =>
    isCalcParticipatingAdjustmentType(key)
  );

  return calcParticipants;
};

export const adjustmentTypesNotParticipatingInCalculations = (
  adjustmentTypes
) => {
  const calcNonParticipants = _pickBy(
    adjustmentTypes,
    (_, key) => !isCalcParticipatingAdjustmentType(key)
  );

  return calcNonParticipants;
};
